export default __webpack_public_path__ + "static/Moneywecan_logo-28dfe78e6cd429977fd5db35a677a00e.jpeg";